import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Navbar from '../Header/Navbar'
import NavbarSecond from '../Header/NavbarSecond'
import MobileNavbar from '../Header/MobileNavbar'
import Footer from '../Footer/Footer'
import KnowledgeCentrePageBanner from './KnowledgeCentrePageBanner/KnowledgeCentrePageBanner'
import KnowledgeCentrePageContent from './KnowledgeCentrePageContent/KnowledgeCentrePageContent'
import KnowledgeCentrePageVideoTuto from './KnowledgeCentrePageContent/KnowledgeCentrePageVideoTuto'
import KnowledgeCentrePageNewsElement from './KnowledgeCentrePageContent/KnowledgeCentrePageNewsElement'
import KnowledgeCenterPageBlogs from './KnowledgeCentrePageContent/KnowledgeCenterPageBlogs'
import { getAllBannerData } from '../../Redux/Action/Action';
import { Helmet } from "react-helmet";
const KnowledgeCentrePage = () => {

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(getAllBannerData());

    }, []);

    const bannerData = useSelector((state) => (state?.Reducer) ? (state?.Reducer?.allBannerDataList?.data?.[0]) : []);


    return (
        <>
           <Helmet>
        {/* Page Title and Meta Tags */}
        <title>Knowledge Center | EAPRO</title>
        <meta
          name="description"
          content="Explore EAPRO Knowledge Center for valuable insights, expert articles, and resources on solar energy solutions. Stay informed and make smarter energy choices with our comprehensive guides."
        />
        <meta name="keywords" content="Knowledge Center" />
        <meta name="robots" content="INDEX,FOLLOW" />
        <link rel="canonical" href="https://www.eapro.in/knowledge-center/" />

       
      </Helmet>
            <Navbar />
            <NavbarSecond />
            <MobileNavbar />
            <KnowledgeCentrePageBanner bannerData={bannerData} />
            <KnowledgeCentrePageVideoTuto bannerData={bannerData} />
            <KnowledgeCenterPageBlogs bannerData={bannerData} />
            <KnowledgeCentrePageNewsElement bannerData={bannerData} />
            <Footer />
        </>
    )
}

export default KnowledgeCentrePage